@if (isFrom === 'associateUfoShipments') {
  <div class="information-note-container info-mode">
    <app-svg-icon
      [iconName]="'saturn'"
      class="load-files-icon"
      [isStaticSvg]="true"></app-svg-icon>
    <span class="ibc-body-text-medium">{{ message }}</span>
  </div>
} @else if (
  isFrom === 'multiPieceShortageGateway' || isFrom === 'bagGatewayWizard'
) {
  <div class="information-note-container info-mode">
    <app-svg-icon
      [iconName]="'infoCircle'"
      class="help-icon-primary"
      [isStaticSvg]="true"></app-svg-icon>
    <span class="ibc-body-text-medium"> {{ message }} </span>
  </div>
} @else if (isFrom === 'apInvoiceFetchFromSFTP') {
  @if (mode === 'info') {
    <div class="information-note-container info-mode">
      <app-svg-icon
        [iconName]="'loadFiles'"
        class="load-files-icon"
        [isStaticSvg]="true"></app-svg-icon>
      <span class="ibc-body-text-medium"> {{ message }} </span>
    </div>
  } @else if (mode === 'warning') {
    <div class="information-note-container warning-mode">
      <app-svg-icon
        [iconName]="'warning'"
        class="load-files-icon"
        [isStaticSvg]="true"></app-svg-icon>
        <span class="ibc-body-text-medium"> {{ message }} </span>
    </div>
  }
} @else {
  @if (isFrom === 'invoiceModule' && message?.publishHistory?.length > 1) {
    <div class="publish-history-wrapper">
      @for (history of message.publishHistory; track $index) {
        <div class="publish-history-card">
          <div class="publish-history-header">
            <app-svg-icon
              [iconName]="'invoice'"
              class="invoice-upload cursor"
              [isStaticSvg]="true"></app-svg-icon>
            @if (message?.isMultiInvoice) {
              <span><b>All Invoices</b> published to {{history.publishedTo}}</span>
            } @else {
              <span>Invoice '<b>{{message?.invoiceNumber}}</b>' is published to {{history.publishedTo}}</span>
            }
          </div>
          <div class="publish-history-details">
            <div class="publish-detail-pair">
              <span class="detail-label">Published By :</span>
              <span class="detail-value">
                {{
                ((history.publishedByUser?.firstName || '') + ' ' + (history.publishedByUser?.lastName || ''))
                | titlecase
                }}
              </span>
            </div>
            <div class="publish-detail-pair">
              <span class="detail-label">Published Date :</span>
              <span class="detail-value">{{history.publishedDate | date: 'MM-dd-yyyy HH:mm' : 'UTC'}}</span>
            </div>
          </div>
        </div>
      }
    </div>
  } @else if (isFrom === 'invoiceModule' && message?.publishHistory?.length === 1) {
    <div class="information-container">
      <div class="invoice-published-container">
        <div class="invoice-header-container">
          <app-svg-icon
            [iconName]="'invoice'"
            class="invoice-upload cursor"
            [isStaticSvg]="true"></app-svg-icon>
          @if (message?.isMultiInvoice) {
            <span><b>All Invoices</b> published to {{message.publishHistory[0].publishedTo}}</span>
          } @else {
            <span>Invoice '<b>{{message?.invoiceNumber}}</b>' is published to {{message.publishHistory[0].publishedTo}}</span>
          }
        </div>
        <div class="invoice-details-container">
          <div class="invoice-detail-pair-container">
            <span>Published By:</span>
            <span>
              {{
              ((message.publishHistory[0].publishedByUser?.firstName || '') + ' ' + (message.publishHistory[0].publishedByUser?.lastName || ''))
              | titlecase
              }}
            </span>
          </div>
          <mat-divider [vertical]="true"></mat-divider>
          <div class="invoice-detail-pair-container">
            <span>Published Date:</span>
            <span>{{message.publishHistory[0].publishedDate | date: 'MM-dd-yyyy HH:mm' : 'UTC'}}</span>
          </div>
        </div>
      </div>
    </div>
  } @else {
    <div class="information-container" [class.error-mode]="mode === 'error'">
      @if (isFrom === 'invoiceModule') {
        <div class="invoice-published-container">
          <div class="invoice-header-container">
            <app-svg-icon
              [iconName]="'invoice'"
              class="invoice-upload cursor"
              [isStaticSvg]="true"></app-svg-icon>
              @if (message?.isMultiInvoice) {
                <span><b>All Invoices</b> {{message?.rePublish ? 'Re-Published' : 'Published'}}</span>
              } @else {
                <span>Invoice '<b>{{message?.invoiceNumber}}'</b> is {{message?.rePublish ? 'Re-Published' : 'Published'}}</span>
              }
            </div>
          <div class="invoice-details-container">
            <div class="invoice-detail-pair-container">
              <span>{{message?.rePublish ? 'Re-Published By:' : 'Published By:'}}</span>
              <span>
                {{
                (message?.publishedUser?.firstName ? message?.publishedUser?.firstName : '') +
                (message?.publishedUser?.lastName ? ' ' + message?.publishedUser?.lastName : '')
                | titlecase
                }}
              </span>
            </div>
            <mat-divider [vertical]="true"></mat-divider>
            <div class="invoice-detail-pair-container">
              <span>{{message?.rePublish ? 'Re-Published Date:' : 'Published Date:'}}</span>
              <span>{{message?.publishDate | date: 'MM-dd-yyyy HH:mm' : 'UTC'}}</span>
            </div>
          </div>
        </div>
      } @else {
        <span class="ibc-body-text-large-bold">Information:</span>
        @if (isMessageList && message.length > 1) {
          <ul class="ibc-body-text-regular pt-2 information-list" [class.error-text]="mode === 'error'">
            @for (item of message; track $index) {
              <li>{{ item }}</li>
            }
          </ul>
        } @else {
          <span class="ibc-body-text-regular pt-2" [class.error-text]="mode === 'error'"> {{ isMessageList ? message[0] : message }} </span>
        }
      }
    </div>
  }
}
